import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BusinessDetailsState } from '../reducers/business-details.state';
import { AppState } from 'src/app/store/reducers/app.state';

// Selector functions
const getAppState = createFeatureSelector<AppState>('appstate');

export const getLoaders = createSelector(
  getAppState,
  state => state.loaders
);

const getBusinessDetailsState = createFeatureSelector<BusinessDetailsState>('businessdetailsstate');

export const getBusinessDetails = createSelector(
  getBusinessDetailsState,
  state => state.businessDetails
);

export const getLegalName = createSelector(
  getBusinessDetailsState,
  state => state.legalName
);

export const getFound = createSelector(
  getBusinessDetailsState,
  state => state.found
);


export const getIncorporationDate = createSelector(
  getBusinessDetailsState,
  state => state.incorporationDate
);


export const getOrgbookServiceStatus = createSelector(
  getBusinessDetailsState,
  state => state.isOrgBookServiceDown
);


export const getOrgBookDetails = createSelector(
  getBusinessDetailsState,
  state => state.orgBookDetails
);

export const getInternetRegistration = createSelector(
  getAppState,
  ( state: AppState ) => state.internetRegistration
);